import { z } from 'zod'

const jsonObject = z.record(z.unknown())

export const tcppicture0putPutSidecarLeasesIdEvidenceResponseSchema = jsonObject
export type tcppicture0putPutSidecarLeasesIdEvidenceResponse = z.infer<typeof tcppicture0putPutSidecarLeasesIdEvidenceResponseSchema>
